<template>
    <div class="fill-height full-width">
        <v-layout row>
            <v-flex xs-12>
                <div class="goback">
                    <div class="fm-container">
                        <a v-if="userPermission" @click="returnToGroup()">
                            <i class="fas fa-arrow-left"></i> Return to Group Discussion
                        </a>
                        <a v-else href="/dashboard">
                            <i class="fas fa-arrow-left"></i> Return to Dashboard
                        </a>
                    </div>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs12>
                <div class="fm-container" v-if="userPermission">
                    <file-manager v-if="fileManagerSettings && !groupLoading" v-bind:settings="fileManagerSettings" v-bind:group="group"></file-manager>
                </div>
                <div v-else class="fm-container">
                  <v-card v-if="!groupLoading" elevation-0 class="elevation-0">
                      <v-card-title>
                          <h2>Permission Denied</h2>
                      </v-card-title>
                      <v-card-text>
                          <p>You do not have permission to view files or folders for this group.</p>
                      </v-card-text>
                  </v-card>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<style scoped lang='scss'>
  @import "src/styles/variables.scss";

  .full-width {
      width: 100%;
  }

  .fm-container {
      margin-left: 90px;
      margin-right: 90px
  }

  .goback {
    background: $amaze-yellow-background;
    padding: 15px 0;
      a {
          i {
              padding-right: 0.5em;
          }
          font: bold 15px/24px $amaze-header-font-stack;
          letter-spacing: 0;
          color: black;
      }
  }
</style>

<script>

export default {
  components: { },
  computed: {
    // a computed getter
    access() {
      if (this.group.public) {
        return "Public Group";
      } else {
        return "Private Group";
      }
    },
    changeAccessText() {
      if (this.group.public) {
        return "make private";
      } else {
        return "make public";
      }
    },
    memberCount() {
      if (typeof this.group.users !== "undefined") {
        return this.group.users.length;
      } else {
        return 0;
      }
    },
    loaded: function() {
      return this.cardsLoading == false && this.groupLoading == false;
    }
  },
  data() {
    return {
      group: {
        group_type: { card_types: [{ id: null, class: null }] },
        group_photo: { large: false }
      },
      groupLoading: false,
      userPermission: false,
      cards: [],
      cardsLoading: true,
      currentPage: 1,
      nextPage: 1,
      scrolledToBottom: false,
      showNameField: false,
      showPublicCheck: false,
      groupPhotoLoading: false,
      fileManagerSettings: null
    };
  },
  methods: {
    returnToGroup() {
      this.$router.push({ path: "/group/" + this.group.id });
    },
    setupPage(groupId) {
      this.$store.commit("loading", { loading: true });
      this.cards = [];
      this.getGroupInfo(groupId);
    },
    getGroupInfo(groupId) {
      this.groupLoading = true;

      // For direct linking purposes, check for the folder and file query params.
      const { folder } = this.$route.query;
      const { file } = this.$route.query;

      this.$http.get("groups/" + groupId).then(
        response => {
          this.group = response.data.data;
          this.userPermission = true;

          // Determine the file manager path based on the folder query param.
          let fileManagerPath = this.group.file_manager_path;
          if (folder) {
            fileManagerPath = `file_manager/group/${this.group.id}/${folder}`;
          }

          this.fileManagerSettings = {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Authorization: `Bearer ${window.localStorage.getItem('user-token')}`
            },
            baseUrl: process.env.VUE_APP_API_BASE.replace('api/v1', '') + 'file-manager', // overwrite base url Axios
            windowsConfig: 1,
            leftPath: fileManagerPath,
            rightPath: fileManagerPath,
            basePath: this.group.file_manager_path,
            rootDirectory: this.group.file_manager_path,
            targetFile: file,
            targetFolder: folder
          }
        },
        response => {
          if (response.status === 403) {
            // permissions error
            this.group = false;
            this.userPermission = false;
            this.$store.commit("updateMessage", {
              message: "Error accessing group.",
              snackbar: true
            });
          } else {
            // general error
            console.log("Error pulling group info.", response);
          }
        }
      ).finally(response => {
        this.groupLoading = false;
        // if (this.loaded) {
        this.$store.commit("loading", { loading: false });
        // }
      });
    },
    bottomVisible() {
      const scrollY = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight;
      return bottomOfPage || pageHeight < visible;
    },
    handleScroll() {
      this.scrolledToBottom = this.bottomVisible()
    },

    toggleNameInput() {
      if (this.group.my_role === "admin") {
        this.showNameField = !this.showNameField;
      } else {
        this.showNameField = false;
      }
    },
    togglePublicCheck() {
      if (this.group.my_role === "admin") {
        this.group.public = !this.group.public;
        this.saveGroup();
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!vm.$store.state.loading) {
        vm.$store.commit("loading", { loading: true });
        vm.setupPage(to.params.id);
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (!this.$store.state.loading) {
      this.$store.commit("loading", { loading: true });
      this.setupPage(to.params.id);
    }
    next(); // LEAVE HERE, beforeRouteUpdate doesn't have the same next() callback like beforeRouteEnter
  },
  watch: {

  },
  activated() {
    if (!this.$store.state.loading) {
      this.$store.commit("loading", { loading: true });
      this.setupPage(this.$route.params.id);
    }
  },
  created() {
    this.$store.commit("loading", { loading: true });
    this.setupPage(this.$route.params.id);
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>
